// removed by extract-text-webpack-plugin
module.exports = {"field":"orders-options__field-TKJXj","button":"orders-options__button-2Elz3","title":"orders-options__title-3zvud","controls":"orders-options__controls-35kGp","label":"orders-options__label-aULOS","isDisabled":"orders-options__isDisabled-1F30u","name":"orders-options__name-2mXxf","tooltip":"orders-options__tooltip-1DxUs blocks__tooltip-20lA1 blocks__leftToRight-v7Jyh blocks__error-2TffC blocks__isShown--23z3","tooltipWrapper":"orders-options__tooltipWrapper-1W9El","link":"orders-options__link-10YM7","redirect":"orders-options__redirect-2ssfj"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/orders-options/order-options.css
// module id = 764
// module chunks = 0